import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { IdeaDTO } from './dto/idea.dto';


export class IdeaResponseModel extends GlobalResponseObject {
    data?: any;
    response: IdeaDTO[];
}
export class AllIdeaResponseModel extends GlobalResponseObject{
    data?: IdeaDTO[];
}

export class SignalIdeaResponseModel extends GlobalResponseObject{
    data?: any;
}

